import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { useDealer } from '../../context/DealerContext';
import BookingWizard from '../../components/dealer/BookingWizard';

/** Spec 085 (Flow H) — new booking for a buyer; lands on the booking detail once created. */
export default function NewDealerBookingPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { token, me, walletEnabled } = useDealer();
  if (!token) return null;
  return (
    <div className="dealer-page">
      <div className="dealer-page__header">
        <div>
          <h2>{t('dealer.bookings.new')}</h2>
          <p className="dealer-muted">{t('dealer.wizard.subtitle')}</p>
        </div>
      </div>
      <BookingWizard
        token={token}
        showrooms={me?.showrooms ?? []}
        walletEnabled={walletEnabled}
        onBooked={(b) => navigate(`/dealer/bookings/${b.bookingId}`, { replace: true })}
      />
    </div>
  );
}
